export default __webpack_public_path__ + "static/media/stop_zing_active.99cb8dc8.png";